import { render, staticRenderFns } from "./ReSearchCardStaffBig.vue?vue&type=template&id=8a0ecd1c&scoped=true"
import script from "./ReSearchCardStaffBig.vue?vue&type=script&lang=js"
export * from "./ReSearchCardStaffBig.vue?vue&type=script&lang=js"
import style0 from "./ReSearchCardStaffBig.vue?vue&type=style&index=0&id=8a0ecd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0ecd1c",
  null
  
)

export default component.exports